
import { i18nText } from '@/locales';
import { Form } from "@/form/form";
import { Component } from "vue-property-decorator";
import { ServiceGeneralProductsCreateRequestType } from "@/form/serviceGeneral/serviceGeneralProductsCreate.types";
import { Validate } from "@/plugins/Vuelidate/Decorators";
import { required } from "vuelidate/lib/validators";
import { RequestType } from "../form.types";


@Component
export default class ServiceGeneralProductsCreateForm extends Form {

    @Validate(required, i18nText("Выберите расходники"))
    products: number[] = [];
    @Validate(required, i18nText("Укажите услугу"))
    service_id: number  | null = null;
    quantity: number[]  | null = null;
    product_list: any [] = []

    getFormData() : ServiceGeneralProductsCreateRequestType {
        return {
            product_list: this.product_list,
            service_id: this.service_id,
        }
    }
    
}



export class ConsumablesTypeForm {
    service_id: number  | null = null;
    product_list: Array<ConsumablesType>;

    setFormData(data: ConsumablesTypeAddRequestType): void {
        this.service_id = data.service_id
        this.product_list = data.product_list
    }
    constructor() {
        this.service_id = null
        this.product_list = [{
            product_id: null,
            quantity: null,
            service_id: null,
            store_id: null,
        }]
    }
}

export type ConsumablesAddRequestType = RequestType & {
    store_id: number | null;
    product_id: number | null;
    quantity: number | null;
    service_id: number | null
}

export interface ConsumablesType {
    store_id: number | null;
    product_id: number | null;
    quantity: number | null;
    service_id: number | null
}

export type ConsumablesTypeAddRequestType = RequestType & {
    service_id: number | null;
    product_list:Array<ConsumablesType>
}
